import React, { useCallback } from 'react';

import { useTranslation } from '@lyearn/i18n';
import useNavigation from '@/hooks/useNavigation';
import useParams from '@/hooks/useParams';
import AttachTagsModal from '@/modules/corporate/modules/tags/components/AttachTagsModal';
import routes from '@/pages/corporate/routes';
import { EntityTagInput, TagAvailableOnEnum } from '@/types/schema';

import { DialogProps } from '../../types';

const TAGS_AVAILABLE_ON = [TagAvailableOnEnum.Content];

const Tags: React.FC<DialogProps> = ({ content, onSubmit, onClose }) => {
  const { t } = useTranslation();
  const articleTags = content.tags as EntityTagInput[];
  const { validationError, articleId, ...query } = useParams<Record<string, string>>();
  const navigation = useNavigation();
  const { isLocalizedContent } = content;
  const onSubmitHandler = useCallback(
    async (tags: any) => {
      onSubmit?.({
        tags,
      });
      navigation.replace(routes.ArticleBuilder(articleId!), {
        query,
        appendQuery: false,
      });

      return Promise.resolve(true);
    },
    [articleId, navigation, onSubmit, query],
  );

  return (
    <AttachTagsModal
      availableOn={TAGS_AVAILABLE_ON}
      contentName={t('Common:ResourceTypeSM.Article')}
      hasError={validationError === 'tag'}
      readonly={isLocalizedContent}
      subWorkspaceIds={content.subWorkspaces ?? []}
      tags={articleTags}
      onClose={onClose}
      onSubmit={onSubmitHandler}
    />
  );
};

export default Tags;
